import { ActionTypes } from '../../constants/ActionTypes';

export const onClearUploadFile = () => {
  return {
    type: ActionTypes.CLEAR_UPLOAD_FILE,
  };
};

export const onUploadFile = (
  config: any,
  formData: any,
  letterCode: string | undefined,
  data: any,
) => {
  return {
    type: ActionTypes.UPLOAD_FILE,
    payload: {
      config: config,
      formData: formData,
      letterCode: letterCode,
      data: data,
    },
  };
};

export const onUploadFileSuccess = (action: any) => {
  return {
    type: ActionTypes.UPLOAD_FILE_SUCCESS,
    payload: {
      bodyUploadSuccess: true,
      content: action,
    },
  };
};

export const onDeleteFile = (guid: string | undefined, fileName: string) => {
  return {
    type: ActionTypes.DELETE_FILE,
    payload: {
      guid: guid,
      fileName: fileName,
    },
  };
};

export const onDeleteFileSuccess = () => {
  return {
    type: ActionTypes.DELETE_FILE_SUCCESS,
    payload: {
      bodyDeletedSuccess: true,
    },
  };
};
